// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__aDQc7","container":"style_container__gXKuQ","title":"style_title__s6wcn"};